/**
 * Checks whether a variable is defined.
 *
 * @param {*} variable Variable to check
 */
export function isDefined(variable) {
  return typeof variable !== 'undefined';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-clock/dist/esm/shared/utils.js
// module id = null
// module chunks = 